window.addEventListener('DOMContentLoaded', () => {

    // 人気のおもちゃスライダー
    const argumentClassNames = [ "child", "parent", "gift", "intellectual-education", "original" ]
    argumentClassNames.forEach( argumentClassName => {
        // 年齢選択によって商品表示切り替え
        changeDisplayItems( argumentClassName );
        // カーセルスライダー
        popularCategorySlider( argumentClassName );
    });
})

const changeDisplayItems = ( category ) => {
    const selects = document.querySelectorAll( `.${category}_age_select` );
    const items = document.querySelectorAll( `.popular_collection.${category}_collection .popular_item` );
    const slideButtons = document.querySelectorAll( `.${category}_collection .slide_btn` );
    const productEmpty = document.querySelectorAll(`.popular_collection.${category}_collection .productEmpty`);

    // アイテムが0の時商品がありませんと表示
    if ( items.length == 0 ) {
        productEmpty.forEach( p => {
            p.style.display = 'block';
        });
    } else {
        productEmpty.forEach( p => {
            p.style.display = 'none';
        });
    }

    // アイテムが4つ以上ない時はスライドボタン非表示
    if ( items.length < 4 ) {
        slideButtons.forEach(btn => {
            btn.style.display = "none";
        });
    }

    selects.forEach( select => {
        select.addEventListener ( 'change' , (e) => {
            let itemCount = 0;
            items.forEach( item => {
                item.style.display = "block";
                let age = item.dataset.productAge;
                let value = e.currentTarget.value;
                if ( value != "" && age != value ) {
                    item.style.display = "none";
                } else {
                    itemCount++;
                }
            })
            if (itemCount == 0) {
                productEmpty.forEach( p => {
                    p.style.display = 'block';
                });
            } else {
                productEmpty.forEach( p => {
                    p.style.display = 'none';
                });
            }

            if (itemCount < 4) {
                slideButtons.forEach(btn => {
                    btn.style.display = "none";
                });
            } else {
                slideButtons.forEach(btn => {
                    btn.style.display = "block";
                });
            }
        })
    });
}

const popularCategorySlider = ( category ) => {
    const popularItems = document.querySelector(`.popular_items.${category}_items`);
    const slideButtons = document.querySelectorAll(`.${category}_collection .slide_btn`);
    for ( let btn of slideButtons) {
        btn.addEventListener( 'click', () => {
            let firstItem = document.querySelector(`.popular_items.${category}_items .popular_item:first-child`);
            let lastItem = document.querySelector(`.popular_items.${category}_items .popular_item:last-child`);
            if ( btn.classList.contains('next') ) {
                if (firstItem != null ) {
                    popularItems.append(firstItem);
                }
            } else {
                if (lastItem != null ) {
                    popularItems.prepend(lastItem);
                }
            }
        })
    }
}

